<template>
  <div class="page-content">
   <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
         <div class="col-12">
            <div class="page-title-box d-flex align-items-center justify-content-between">
               <h4 class="mb-0 font-size-18">View Invoice</h4>
               <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                     <li class="breadcrumb-item"><a href="javascript: void(0);">Billing</a></li>
                     <li class="breadcrumb-item active">View Invoice</li>
                  </ol>
               </div>
            </div>
         </div>
      </div>

      <div class="row" v-if="paymentStatus==='success'">
        <div class="col-md-12 pull-md-right main-content">
          <div class="alert alert-success text-center">
            Thank You! Your payment was successful.
          </div>
        </div>
      </div>

      <div class="row" v-if="paymentStatus==='fail'">
        <div class="col-md-12 pull-md-right main-content">
          <div class="alert alert-danger text-center">
            Unfortunately your payment attempt was not successful.<br>
            Please try again or contact support.
          </div>
        </div>
      </div>

      <!-- end page title -->
      <!-- end row -->
      <div class="row">
         <div class="col-lg-12">
            <div class="card">
               <div class="card-body">
                  <div class="invoice-title">
                     <h4 class="float-right font-size-16">Invoice #{{ invoice.id }}</h4>
                     <div class="mb-4">
                        <img src="../../../assets/images/SPACEMINE-latest.svg" alt="logo" height="17"/>
                     </div>
                  </div>
                  <hr>
                  <div class="row">
                     <div class="col-sm-6">
                        <address>
                           <strong>Invoiced To:</strong><br>
                           {{ invoice.client.name }}
                           <br>
                           {{ invoice.client.address1}} {{ invoice.client.address2 }}<br>
                           {{ invoice.client.city}}, {{ invoice.client.postcode}}
                        </address>
                     </div>
                     <div class="col-sm-6 text-sm-right">
                        <address class="mt-2 mt-sm-0">
                           <strong>Pay To:</strong><br>
                           SpaceMine Ltd.<br>
                           Kemp House<br>
                           160 City Road<br>
                           London, EC1V 2NX
                        </address>
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-sm-6 mt-3">
                        <address>
                           <strong>Payment Method:</strong><br>
                           {{ invoice.paymentMethod | titleCase }}<br><br>
                           <strong>Payment Status:</strong><br>
                           <span :class="statusClass(invoice.status)">{{ invoice.status }}</span><br>
                        </address>
                     </div>
                     <div class="col-sm-6 mt-3 text-sm-right">
                        <address>
                           <strong>Invoice Date:</strong><br>
                           {{ invoice.date | displayDate}}<br><br>
                           <strong>Due Date:</strong><br>
                           {{ invoice.due | displayDate }}<br><br>
                        </address>
                     </div>
                  </div>
                  <div class="py-2 mt-3">
                     <h3 class="font-size-15 font-weight-bold">Invoice Items</h3>
                  </div>
                  <div class="table-responsive">
                     <table class="table table-nowrap">
                        <thead>
                           <tr>
                              <th># </th>
                              <th>Item</th>
                              <th class="text-right">Price</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr v-bind:key="item.id" v-for="item in invoice.items">
                              <td>{{ item.id }}</td>
                              <td>{{ item.description}}</td>
                              <td class="text-right">£ {{item.amount}}</td>
                           </tr>
                           <tr>
                              <td colspan="2" class="text-right">Subtotal</td>
                              <td class="text-right">£{{ invoice.subtotal }}</td>
                           </tr>
                           <tr>
                              <td colspan="2" class="border-0 text-right">
                                 <strong>VAT {{ '(' +  invoice.taxRate + '%)' }}</strong>
                              </td>
                              <td class="border-0 text-right">£{{ invoice.taxAmount}}</td>
                           </tr>
                           <tr>
                              <td colspan="2" class="border-0 text-right">
                                 <strong>Total</strong>
                              </td>
                              <td class="border-0 text-right">
                                 <h4 class="m-0">£{{ invoice.total }}</h4>
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <div class="d-print-none">
                     <div class="float-right">
                        <form action="https://www.sandbox.paypal.com/cgi-bin/webscr" method="post">
                          <input type="hidden" name="cmd" value="_xclick">
                          <input type="hidden" name="business" value="sb-t7dxs3288310@business.example.com">
                          <input type="hidden" name="item_name" :value="'SpaceMine Ltd - Invoice #' + invoice.id">
                          <input type="hidden" name="amount" :value="invoice.subtotal">
                          <input type="hidden" name="tax" :value="invoice.taxAmount">
                          <input type="hidden" name="no_note" value="1">
                          <input type="hidden" name="no_shipping" value="1">
                          <input type="hidden" name="address_override" value="0">
                          <input type="hidden" name="first_name" :value="invoice.client.firstname">
                          <input type="hidden" name="last_name" :value="invoice.client.lastname">
                          <input type="hidden" name="email" :value="invoice.client.email">
                          <input type="hidden" name="address1" :value="invoice.client.address1">
                          <input type="hidden" name="city" :value="invoice.client.city">
                          <input type="hidden" name="state" :value="invoice.client.state">
                          <input type="hidden" name="zip" :value="invoice.client.postcode">
                          <input type="hidden" name="country" :value="invoice.client.country">
                          <input type="hidden" name="charset" value="utf-8">
                          <input type="hidden" name="currency_code" :value="invoice.client.currencyCode">
                          <input type="hidden" name="custom" :value="invoice.id">
                          <input type="hidden" name="return" :value="currentUrl + '?paymentsuccess=true'">
                          <input type="hidden" name="cancel_return" :value="currentUrl + '?paymentfailed=true'">
                          <input type="hidden" name="notify_url" value="http://wc.jacyhung.com/modules/gateways/callback/paypal.php">
                          <input type="hidden" name="bn" value="WHMCS_ST">
                          <input type="hidden" name="rm" value="1">
                          <input type="submit" class="btn btn-primary w-md waves-effect waves-light" :disabled="invoice.status=='Paid'" name="submit" value="Pay" alt="Make a one time payment with PayPal">
                          </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- end row -->
      <!-- end row -->
      <!-- end row -->
      <!-- end row -->
   </div>
</div>
</template>

<script>
import store from '../../../store'
export default {
  name: 'ViewInvoice',
  data () {
    return {
      currentUrl: '',
      invoice: {}
    }
  },
  computed: {
    paymentStatus: function () {
      if (!this.$route.hasOwnProperty('query')) return ''
      if (this.$route.query.hasOwnProperty('paymentsuccess')) return 'success'
      if (this.$route.query.hasOwnProperty('paymentfailed')) return 'fail'
    }
  },
  filters: {
    displayDate: function (ddate) {
      var dateObj = new Date(ddate)
      if (dateObj == 'Invalid Date') return 'N/A'
      return dateObj.toDateString()
    },
    titleCase: function (phrase) {
      return (typeof phrase === 'undefined') ? '' : phrase.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
    }
  },
  mounted () {
    this.getInvoice()
    console.log(this.$route)
    console.log(this.$route.query)
    console.log(this.$route.query.page)
  },
  updated () {
    this.currentUrl = window.location.href
  },
  methods: {
    getInvoice () {
      let invoiceId = this.$route.params.id || -1
      fetch(store.state.url + '/billing/invoice/' + invoiceId + '/view', {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + store.state.token
        }
      }).then(response => {
        return response.json()
      }).then(data => {
        this.invoice = data
        console.log(data)
      }).catch(err => {
        console.error(err)
      })
    },
    statusClass (status) {
      console.log(status)
      var baseClass = 'badge badge-pill font-size-12 badge-soft-'
      switch (status) {
        case 'Active':
          baseClass += 'success'
          break
        case 'Completed':
          baseClass += 'success'
          break
        case 'Paid':
          baseClass += 'success'
          break
        case 'Draft':
          baseClass += 'light'
          break
        case 'Unpaid':
          baseClass += 'danger'
          break
        case 'Overdue':
          baseClass += 'danger'
          break
        case 'Cancelled':
          baseClass += 'secondary'
          break
        case 'Refunded':
          baseClass += 'info'
          break
        case 'Collections':
          baseClass += 'primary'
          break
        case 'Pending':
          baseClass += 'warning'
          break
        case 'Paymemnt Pending':
          baseClass += 'warning'
          break
        case 'Suspended':
          baseClass += 'danger'
          break
        case 'Termindated':
          baseClass += 'danger'
          break
        case 'Fraud':
          baseClass += 'danger'
          break
        default:
          baseClass += 'info'
      }
      return baseClass
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/management/billing/ViewInvoice.vue